import type { FaireProductEntity } from "../../entity_types/product";

export const p_svg3dtmdfu: FaireProductEntity = {
  token: "p_svg3dtmdfu",
  type: "product",
  name: "party hat mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5736187fe5805a30fd0b2fdfcdf0fd43f3c0c8a7d0916c9e32aa10ef46e857e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/11fffaa83e9e805cfa39443c5407465061314692666a06eaa5c861ac72401a27.jpeg",
    "https://cdn.faire.com/fastly/9dec1c7fde064c0de84fdc549961fcefbf36c937aaad904d9704db911d0d61d0.jpeg",
    "https://cdn.faire.com/fastly/80029d8e40de659340fc375ccfe1ecda44c5d04be7807ba76827f112cadc3e87.jpeg",
    "https://cdn.faire.com/fastly/c4e037c54ef32cad11b06a7fc1afd3e07929e38e3dfecd4f79ba1f401945a123.jpeg",
    "https://cdn.faire.com/fastly/49cb22efc7ba1cc6e016f40002ebc2168af2d9130e6559f56295f9f2e2e13a06.jpeg",
    "https://cdn.faire.com/fastly/77cde735bec62ab375f111ef525b13a7368c3631cba4ed1fc74d5ec1ea609b11.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:49.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
